export default __webpack_public_path__ + "static/media/calculator.651a7241.svg";